var axiosConstructor = function (axios, config) {
    return axios.create(config);
};
export { axiosConstructor };
